import styled from 'styled-components';

export const Container = styled.div`
  z-index: 100;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: ${(props) => props.theme.palette.gray5};
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
